module.exports = __webpack_public_path__ + "static/media/jawbreaker-removal-portuguese.cdeac54c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/switchlock/video/pr/jawbreaker-removal-portuguese.mp4
// module id = 3484
// module chunks = 0